// extracted by mini-css-extract-plugin
export var subscribe = "styles-module--subscribe--ybOZW";
export var subscribe_title = "styles-module--subscribe_title--3s0eH";
export var subscribe_l = "styles-module--subscribe_l--qZfh1";
export var subscribe_r = "styles-module--subscribe_r--2txRH";